import { PrivateModeSessionExpiry } from "rujira.ui";
import { useRedactedV2 } from "../../redacted/v2";
import { useAccounts } from "../../services/accounts";

export const PrivateSessionExpiry = () => {
  const session = useRedactedV2();
  const { selected } = useAccounts();
  return (
    <PrivateModeSessionExpiry
      controls={session}
      available={session.enabled && !!selected}
    />
  );
};
